import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export default function BudgetBasicInfoComponent({
  handleInnerFormChange, selectedBudgets, financialYearsList, methodTypesList, budgeTypesList, departmentsList, projectsList
}: any) {

  return (
    <>
      <AccordionContainer
        child={
          <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Book Begin Date"
              labelField="BookBeginDate"
              list={financialYearsList}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'FinancialYearId'
                )
              }}
              optionName='Choose Book Begin Date'
              type="select"
              value={selectedBudgets?.FinancialYearId}
              valueField="Id"
            />
            <InputContainer
              label="Account Code"
              name="AccountCode"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'AccountCode',
                )
              }}
              type="text"
              value={selectedBudgets?.AccountCode}
            />
            <InputContainer
              label="Method Type"
              labelField="Text"
              list={methodTypesList}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MethodTypeId'
                )
              }}
              optionName='Choose Method Type'
              type="select"
              value={selectedBudgets?.MethodTypeId}
              valueField="Value"
            />
            {selectedBudgets?.MethodTypeId === 20 && (
              <InputContainer
                label="Department"
                labelField="Name"
                list={departmentsList}
                onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'DepartmentId'
                  );
                }}
                optionName='Choose Department Name'
                type="select"
                value={selectedBudgets?.DepartmentId}
                valueField="Id"
              />
            )}
            {selectedBudgets?.MethodTypeId === 30 && (
              <InputContainer
                label="Project"
                labelField="Name"
                list={projectsList}
                onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'ProjectId'
                  );
                }}
                optionName='Choose Project Name'
                type="select"
                value={selectedBudgets?.ProjectId}
                valueField="Id"
              />
            )}
            <InputContainer
              label="Budget Type"
              labelField="Text"
              list={budgeTypesList}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'TypeId'
                )
              }}
              optionName='Choose Budget Type'
              type="select"
              value={selectedBudgets?.TypeId}
              valueField="Value"
            />
            {selectedBudgets?.TypeId !== 10 && (
              <InputContainer
                label="Date"
                name="Date"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'DateInUtc'
                  )
                }}
                type="date"
                value={selectedBudgets?.DateInUtc}
              />
            )}
            {selectedBudgets?.TypeId !== 10 && (
              <InputContainer
                label="To Date"
                name="ToDate"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'ToDateInUtc'
                  )
                }}
                type="date"
                value={selectedBudgets?.ToDateInUtc}
              />
            )}
            <InputContainer
              label="Amount"
              name="Amount"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Amount'
                );
              }}
              type="number"
              value={selectedBudgets?.Amount}
            />
            <InputContainer
              label="Remarks"
              labelField="Remarks"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Remarks'
                );
              }}
              type="text"
              value={selectedBudgets?.Remarks}
            />
          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Budget Info"
      />
    </>
  )
}